import React, { useEffect, useState } from "react";
import styles from './TransientTab.module.scss';

import MarkdownRenderer from '../../../utils/MarkdownRenderer/MarkdownRenderer';
import ImageEditor from '../../../utils/ImageEditor/ImageEditor';
import { DEBUG, PATH } from '../../../utils/constants';


import { getAllGrids, createGrid, updateGridName, updateGridSteps, updateGridDescription, updateGridImage, deleteGridImage, toggleGrid, getLastInsertedGame, toggleGridPlaces, toggleGridHints } from "../../../utils/api/transientGameAPI";


const debug = DEBUG;
const path = PATH;


export default function TransientTab() {
  const [grids, setGrids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [mode, setMode] = useState("edit"); // list | add | edit
  const [currentGrid, setCurrentGrid] = useState(null);


  const [originalName, setOriginalName] = useState("");
  const [nameUpdateMessage, setNameUpdateMessage] = useState(null);
  
  const [originalDescription, setOriginalDescription] = useState("");
  const [descriptionUpdateMessage, setDescriptionUpdateMessage] = useState(null);

  // Mise à jour du nombre d'étapes
  const [originalSteps, setOriginalSteps] = useState(0);
  const [stepsUpdateMessage, setStepsUpdateMessage] = useState(null);

  // Mise à jour de l'image du jeu
  const [imageFile, setImageFile] = useState(null);
  const [imageUpdateMessage, setImageUpdateMessage] = useState(null);

  // Pour mise à jour de l'image dans le composant ImageEditor
  const [canUpdatePreview, setCanUpdatePreview] = useState(false);

  // Form state
  const [form, setForm] = useState({
      nom: "",
      description: "",
      steps: 0,
      active: true,
      hasPlaces: true,
      hasHints: true,
      image: null
  });

  // Useffect temporaire, à supprimer pour réactiver la gestion de la liste des jeux éphémères
  useEffect(() => {
    async function loadLastGame() {
      try {
          const lastGame = await getLastInsertedGame();
          if (lastGame) {
              handleEditClick(lastGame);  // ou bien intègre tout ici
              setLoading(false);          }
      } catch (error) {
          if (debug) console.error("Erreur lors du chargement du dernier jeu :", error);
      }
  }

  loadLastGame();
  }, []);

  useEffect(() => {
    if (nameUpdateMessage) {
        const timer = setTimeout(() => setNameUpdateMessage(null), 4000);
        return () => clearTimeout(timer);
    }
  }, [nameUpdateMessage]);

  useEffect(() => {
      if (descriptionUpdateMessage) {
          const timer = setTimeout(() => setDescriptionUpdateMessage(null), 4000);
          return () => clearTimeout(timer);
      }
  }, [descriptionUpdateMessage]);

  useEffect(() => {
      if (stepsUpdateMessage) {
          const timer = setTimeout(() => setStepsUpdateMessage(null), 4000);
          return () => clearTimeout(timer);
      }
  }, [stepsUpdateMessage]);

  useEffect(() => {
      if (imageUpdateMessage) {
          const timer = setTimeout(() => setImageUpdateMessage(null), 4000);
          return () => clearTimeout(timer);
      }
  }, [imageUpdateMessage]);


  // A réactiver pour gérer la liste des jeux éphémères
  // useEffect(() => {
  //     fetchGrids();
  // }, []);

  // async function fetchGrids() {
  //     try {
  //         setLoading(true);
  //         const data = await getAllGrids();
  //         setGrids(data);
  //     } catch (e) {
  //         setError("Erreur de chargement des jeux.");
  //     } finally {
  //         setLoading(false);
  //     }
  // }

  function handleChange(e) {
      const { name, value, type, checked, files } = e.target;
      if (type === "checkbox") {
          setForm({ ...form, [name]: checked });
      } else if (type === "file") {
          setForm({ ...form, [name]: files[0] });
      } else {
          setForm({ ...form, [name]: value });
      }
  }

  function handleAddClick() {
      setForm({ nom: "", description: "", steps: 0, active: true, image: null });
      setMode("add");
  }

  function handleEditClick(grid) { // à transformer en useffect temporairement

    setOriginalName(grid.nom);
    setNameUpdateMessage(null);

    setOriginalDescription(grid.description);
    setDescriptionUpdateMessage(null);

    setOriginalSteps(grid.steps);
    setStepsUpdateMessage(null);

    setImageFile(null);

    setForm({
        nom: grid.nom,
        description: grid.description,
        steps: grid.steps,
        active: grid.active === 1 || grid.active === true,
        hasPlaces: grid.places === 1 || grid.places === true,
        hasHints: grid.hints === 1 || grid.hints === true,
        image: null
    });
    setCurrentGrid(grid);
    setMode("edit");
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
        if (mode === "add") {
            await createGrid(form.nom, form.description, form.steps, form.active, true, true, form.image);
        } else if (mode === "edit") {
            // await updateGrid(currentGrid.id, form.nom, form.description, form.steps, form.active);
        }
        // await fetchGrids(); // A remettre pour réactiver la liste des jeux
        setMode("edit"); // A remettre à "list" lors de la réactivation de la liste des jeux
    } catch (e) {
        setError("Erreur lors de la sauvegarde.");
    }
  }

  async function handleUpdateName() {
    try {
        const response = await updateGridName(currentGrid.id, form.nom);
        setNameUpdateMessage({ text: response.message, success: response.success });
        if (response.success) setOriginalName(form.nom);
    } catch (e) {
        setNameUpdateMessage({ text: "Erreur serveur", success: false });
    }
  }

  async function handleUpdateDescription() {
    try {
        const response = await updateGridDescription(currentGrid.id, form.description);
        setDescriptionUpdateMessage({ text: response.message, success: response.success });
        if (response.success) setOriginalDescription(form.description);
    } catch (e) {
        setDescriptionUpdateMessage({ text: "Erreur serveur", success: false });
    }
  }

  async function handleUpdateSteps() {
      try {
          const response = await updateGridSteps(currentGrid.id, form.steps);
          setStepsUpdateMessage({ text: response.message, success: response.success });
          if (response.success) setOriginalSteps(form.steps);
      } catch (e) {
          setStepsUpdateMessage({ text: "Erreur serveur", success: false });
      }
  }


  if (loading) return <p>Chargement...</p>;
  if (error) return <p>{error}</p>;

 
  if (mode !== "list") {
    return (
      <div className={styles.tabContainer}>
        <h2 className={styles.title}>{mode === "add" ? "Ajouter un nouveau jeu" : "Modifier le jeu"}</h2>
        <form className={styles.form} onSubmit={handleSubmit}>

          {mode === "edit" && (
            <>
              <div className={styles.active}>
                <label>
                  Activer/ Désactiver le jeu &nbsp;
                  <label className={styles.switch}>
                    <input type="checkbox" checked={!!form.active}
                        onChange={async (e) => {
                            const newValue = e.target.checked;
                            setForm({ ...form, active: newValue });

                            try {
                                const response = await toggleGrid(currentGrid.id, newValue);
                                if (debug) console.log(response.message);
                            } catch (err) {
                                if (debug) console.error("Erreur toggle active :", err);
                            }
                        }}
                    />
                    <span className={styles.slider}></span>
                  </label>
                </label>
              </div>

              <hr className={styles.hr} />

              <div className={styles.active}>
                <label>
                    Activer/ Désactiver les lieux &nbsp;
                    <label className={styles.switch}>
                      <input type="checkbox" checked={!!form.hasPlaces}
                        onChange={async (e) => {
                          const newValue = e.target.checked;
                          setForm({ ...form, hasPlaces: newValue });

                          try {
                              const response = await toggleGridPlaces(currentGrid.id, newValue ? 1 : 0);
                              if (debug) console.log(response.message);
                          } catch (err) {
                              if (debug) console.error("Erreur toggle places :", err);
                          }
                        }}
                      />
                      <span className={styles.slider}></span>
                    </label>
                </label>
              </div>

              <div className={styles.active}>
                <label>
                  Activer/ Désactiver les indices &nbsp;
                  <label className={styles.switch}>
                    <input type="checkbox" checked={!!form.hasHints}
                      onChange={async (e) => {
                        const newValue = e.target.checked;
                        setForm({ ...form, hasHints: newValue });

                        try {
                          const response = await toggleGridHints(currentGrid.id, newValue ? 1 : 0);
                          if (debug) console.log(response.message);
                        } catch (err) {
                          if (debug) console.error("Erreur toggle hints :", err);
                        }
                      }}
                    />
                    <span className={styles.slider}></span>
                  </label>
                </label>
              </div>
            </>
          )}

          <label htmlFor="nom" className={styles.label}>Nom du jeu :</label>
          <div>
            <input className={styles.input} type="text" id="nom" name="nom" placeholder="Nom" value={form.nom} onChange={handleChange} required />
            {mode === "edit" && (
              <>
                <button className={styles.button} type="button" onClick={handleUpdateName} disabled={form.nom === originalName} > Modifier le nom du jeu</button>
                {nameUpdateMessage && (
                  <p style={{ color: nameUpdateMessage.success ? "var(--color-success-hover)" : "var(--color-alert)", marginTop: "5px" }}> {nameUpdateMessage.text} </p>
                )}
              </>
            )}
          </div>

          <hr className={styles.hr} />

          <label htmlFor="description" className={styles.label}>Description / Texte d'introduction :</label>
          <div>
            <textarea className={styles.textarea} id="description" name="description" placeholder="Description" value={form.description} onChange={handleChange} />
            {mode === "edit" && (
              <>
                <button className={styles.button} type="button" onClick={handleUpdateDescription} disabled={form.description === originalDescription} > Modifier la description </button>
                {descriptionUpdateMessage && (
                  <p style={{ color: descriptionUpdateMessage.success ? "var(--color-success-hover)" : "var(--color-alert)", marginTop: "5px" }}> {descriptionUpdateMessage.text} </p>
                )}
              </>
            )}
          </div>

          <hr className={styles.hr} />

          <label htmlFor="steps" className={styles.label}>Nombre d'étapes :</label>
          <div>
            <input className={styles.input} type="number" id="steps" name="steps" placeholder="Nombre d'étapes" value={form.steps} onChange={handleChange} />
            {mode === "edit" && (
              <>
                <button className={styles.button} type="button" onClick={handleUpdateSteps} disabled={form.steps === originalSteps} > Modifier le nombre d'étapes </button>
                {stepsUpdateMessage && (
                  <p style={{ color: stepsUpdateMessage.success ? "green" : "red", marginTop: "5px" }}>
                    {stepsUpdateMessage.text}
                  </p>
                )}
              </>
            )}
          </div>

          <hr className={styles.hr} />

          {mode === "add" && (
              <input type="file" name="image" accept="image/*" onChange={handleChange} />
          )}

          {mode === "edit" && (
            <div>
              <ImageEditor
                  initialImage={currentGrid.image ? `${path}${currentGrid.image}` : null}
                  canUpdatePreview={canUpdatePreview}
                  onLocalChange={async (file) => {
                    setCanUpdatePreview(false); // désactive avant upload
                    try {
                      const response = await updateGridImage(currentGrid.id, file);
                      setImageUpdateMessage({ text: response.message, success: response.success });
                      if (response.success) {
                        setCanUpdatePreview(true); // autorise la preview
                      }
                    } catch (err) {
                      if (debug) console.error("Erreur update image :", err);
                      setImageUpdateMessage({ text: "Erreur lors de l’upload.", success: false });
                    }
                  }}
                  onDelete={async () => {
                    if (!currentGrid || !currentGrid.image) return;
                    try {
                        const response = await deleteGridImage(currentGrid.id, currentGrid.image);
                        if(debug) console.log(response.message);
                        // Optionnel : update image in grid or refresh
                    } catch (err) {
                      if(debug)console.error("Erreur delete image :", err);
                    }
                }}
              />
              {imageUpdateMessage && (
                <p style={{ color: imageUpdateMessage.success ? "green" : "red", marginTop: "5px" }}>
                  {imageUpdateMessage.text}
                </p>
              )}
            </div>
          )}

          
          {/* <button type="submit">Valider</button> */}
          {/* <button type="button" onClick={() => setMode("list")}>Annuler</button> */}
        </form>
      </div>
    );
  }

  return (
      <div>
          <h2>Jeux éphémères</h2>
          {grids.length === 0 ? (
              <p>Aucun jeu disponible.</p>
          ) : (
              <ul>
                  {grids.map(grid => (
                      <li key={grid.id}>
                          {grid.nom} ({grid.steps} étapes) - {grid.active ? "Actif" : "Inactif"}
                          <button onClick={() => handleEditClick(grid)}>Modifier</button>
                      </li>
                  ))}
              </ul>
          )}
          <button onClick={handleAddClick}>Ajouter un nouveau jeu</button>
      </div>
  );
}